import { browserHistory } from 'react-router';
import { ref, firebaseAuth, setAuthUser } from './firebase.js';

const provider = new firebaseAuth.FacebookAuthProvider();
provider.addScope('email');

class Auth {

  saveUser(result) {
    // This gives you a Facebook Access Token. You can use it to access the Facebook API.
    var token = result.credential.accessToken;
    // The signed-in user info.
    var user = result.user;
    return ref.child(`users/${user.uid}/info`)
    .set({
      displayName: user.displayName,
      email: user.email,
      emailVerified: user.emailVerified,
      photoURL: user.photoURL,
      uid: user.uid,
      token: token
    })
    .then(() => user);
  }

  get currentUser() {
    return firebaseAuth().currentUser;
  }

  requireAuth(nextState, replaceState, callback) {
    firebaseAuth().onAuthStateChanged((user) => {
      if (!user) {
        replaceState({
          pathname: '/login',
          state: { nextPathname: nextState.location.pathname },
        });
      } else {
        nextState.params.uid = user.uid;
        setAuthUser(user.uid);
      }
      callback();
    });
  }

  login() {
    return firebaseAuth().signInWithPopup(provider)
    .then(this.saveUser)
    .then( (user) => {
      if(user) {
        browserHistory.push('/');
      }
    })
    .catch(function(error) {
      console.error('Error signing in.', error);
    });
  }

  logout() {
    return firebaseAuth().signOut().then(function() {
      browserHistory.push('/');
    }, function(error) {
      console.error('Error signing out.', error);
    });
  }

}

export default Auth;



// WEBPACK FOOTER //
// ./src/utils/auth.js